import { render, staticRenderFns } from "./structure-create.vue?vue&type=template&id=eb2a9e60"
import script from "./structure-create.vue?vue&type=script&lang=js"
export * from "./structure-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports